import { AccountDashboardFilters, AccountStatusNames } from '@copilot/common/pages/accountDashboard/types';

/**
 * Default account filters that is set initially
 */
export const DEFAULT_ACCOUNT_DASHBOARD_FILTERS: AccountDashboardFilters = {
  search: '',
  searchUppercase: '',
  accountStatus: AccountStatusNames.Active,
  accountManagerId: undefined,
  linkedInDisconnected: false,
};

export const EMPTY_DATA_MESSAGE = "You haven't added accounts to the dashboard.";
export const NO_RESULT_MESSAGE = 'No result found';